"use strict";

exports["default"] = function (obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
};

exports.__esModule = true;


/*****************
 ** WEBPACK FOOTER
 ** ../~/babel-runtime/helpers/interop-require-default.js
 ** module id = 82
 ** module chunks = 0
 **/